// extracted by mini-css-extract-plugin
module.exports = {"placeholderButton":"styles__placeholderButton___3sYBb","placeholderImage":"styles__placeholderImage___3wgnR","videoWrapper":"styles__videoWrapper___3HnBn"};